export default __webpack_public_path__ + "static/creative-cf7fd798d26049ab31c5f00758db35d9.jpg";